import { Outlet, NavLink } from "react-router-dom";
import React, {useState} from 'react';


const Menu = () => {
  var sessionmenu = "";

  //var Sessionmenu = <li><NavLink exact="true" to="/sessions/"><span className="material-icons-outlined">menu_book</span> Archive Sessions</NavLink></li>;

    /******call this useEffect when again come to component with and without refresh**********/
    // useEffect(() => {
    //     Sessionmenu = <li><NavLink exact="true" to="/sessions/"><span className="material-icons-outlined">menu_book</span> Archive Sessions</NavLink></li>
    // })

  /******get data from localstorage*******/
  let authlogin = localStorage.getItem('authlogin');
  let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";
  var initialUsername = storageDataAuthLogin ? storageDataAuthLogin.user_email :  "";

  

  /******For Humber Menu******/
  const [isActive, setActive] = useState("false");

  /******Community Menu******/
  const [DropdownActive, setdropActive] = useState("false");


  const ToggleClass = () => {
    setActive(!isActive);
  };

  const DropdownToggle = () => {
    setdropActive(!DropdownActive);
  };

  const DropdownToggleFalse = () => {
    setdropActive("false");
  }

//if(initialUsername==="vip@ciisummit.com" || initialUsername==="VIP@CIISUMMIT.COM" || initialUsername==="cleartrail@ciisummit.com"){
  sessionmenu = <li><NavLink onClick={DropdownToggleFalse} exact="true" to="/sessions/"><span className="material-icons-outlined">archive</span> Archives</NavLink></li>
  //}

  return (
    <>

    <button type="button" className="toggleMenuButton" onClick={ToggleClass}>
      <span> 
        <span></span>
        <span></span>
        <span></span>
      </span> Menu
      
    </button>
     <div className={isActive ? "menuList" : "menuList open"}>

        <button type="button" className="MenuCloseBtn" onClick={ToggleClass}><span className="material-icons-outlined">close</span> Close</button>
    
          <ul>
            {/* <li className="">
              <button className="menu-btn" onClick={DropdownToggle}><span className="material-icons-outlined">local_library</span>  Community</button>
              <ul className={DropdownActive ? "menu-dropdown" : "menu-dropdown open"}>
                <li><NavLink exact="true" activeclass="active" onClick={DropdownToggleFalse} to="/queries">Queries</NavLink></li>
                <li><NavLink exact="true" activeclass="active" onClick={DropdownToggleFalse} to="/add-query">Ask New Query</NavLink></li>
                <li><NavLink exact="true" activeclass="active" onClick={DropdownToggleFalse} to="/my-account">My Account</NavLink></li>
              </ul>

            </li> */}
            <li><NavLink exact="true" activeclass="active" onClick={DropdownToggleFalse} to="/knowledge-center/?data=clear-trail"><span className="material-icons-outlined">menu_book</span> Knowledge Center</NavLink></li>
            {/* {sessionmenu} */}
            
          </ul>

     </div>
     <Outlet />
    </>
  )
};

// const Menu = () => {

//   let authlogin = localStorage.getItem('authlogin');
//   let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";

//   console.log(storageDataAuthLogin.country);
//   console.log("Menu check");
//   return (
//     <>
//      <div className="menuList">
    
//           <ul>
//             <li><NavLink exact="true" activeclass="active" to="/knowledge-center/?data=clear-trail"><span className="material-icons-outlined">menu_book</span> Knowledge Center</NavLink></li>
//             {storageDataAuthLogin.country == "India" &&
//               <li><NavLink exact="true" to="/sessions/"><span className="material-icons-outlined">topic</span> Archives</NavLink></li>
//             }
//           </ul>

//      </div>
//      <Outlet />
//     </>
//   )
// };

export default Menu;